<template>
  <q-card style="width: 900px; max-width: 350vw">
    <q-card-section>
      <div class="text-h6">採購審核明細</div>
      <div v-if="purchaseCheckDetail.status === 0" class="row justify-end q-gutter-xs" >
        <div  class="col col-xs-2 col-sm-2 col-md-2 col-lg-2">
          <q-btn color="purple" icon="done_all" label="確認通過" stack @click="handlePurchasePassClick"></q-btn>
        </div>
        <div class="col col-xs-2 col-sm-2 col-md-1 col-lg-1">
          <q-btn color="green" icon="save" label="儲存" stack @click="purchaseCheckUpdate"></q-btn>
        </div>
        
      </div>
      <div class="row q-gutter-xs">
        <div class="col col-5">
          <q-input v-model="purchaseCheckStatus[purchaseCheckDetail.status]" readonly label="狀態"></q-input>
        </div>
        <div class="col col-6">
          <q-input v-model="purchaseCheckDetail.check_no" readonly label="審核單號" ></q-input>
        </div>
        <div class="col col-5">
          <q-input v-model="purchaseCheckDetail.created_at" readonly label="建立日期" ></q-input>
        </div>
        <div class="col col-6">
          <q-input v-model="purchaseCheckDetail.note" readonly label="備註" ></q-input>
        </div>
        <div v-if="purchaseCheckDetail.purchase_id" class="col col-6">
          <router-link :to="'/purchase/offline-edit/'+purchaseCheckDetail.purchase_id" target="_blank">
            <q-btn label="本地採購單連結" color="blue" ></q-btn>
          </router-link>
          
        </div>
        <div class="col col-12">
          <q-table
            title=""
            :data="purchaseCheckDetail.PurchaseProduct"
            :columns="columns"
            row-key="title"
            :filter="filter"
            :pagination.sync="tableSet"
          >
            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td key="status" :props="props">{{ purchaseCheckStatus[props.row.status] }}</q-td>
                <q-td key="title" :props="props">{{ props.row.detail.title }}</q-td>
                <q-td key="safeStock" :props="props">{{ props.row.detail.safe_stock }}</q-td>
                <q-td key="totalStock" :props="props">{{ props.row.total_stock}}</q-td>
                <q-td key="quantity" :props="props">
                  <q-input v-model="props.row.buy"></q-input>
                </q-td>
                <q-td key="price" :props="props">
                  <q-input v-if="false" v-model="props.row.answer_price"></q-input>  
                  {{ props.row.answer_price }}
                </q-td>
                <q-td v-if="false" key="date" :props="props">{{ props.row.created_at }}</q-td>
                <q-td key="action" :props="props">
                  <q-btn v-if="purchaseCheckDetail.status === 0" color="blue" icon="done" @click="props.row.status = 1" class="q-mr-xs"></q-btn>
                  <q-btn v-if="purchaseCheckDetail.status === 0" color="red" icon="delete" @click="props.row.status = 2"></q-btn>
                  
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
      </div>
    </q-card-section>

    <q-card-actions align="right">
      <q-btn flat label="回審核列表" color="green" icon="arrow_circle_left" @click="handleClickReturnEvent"></q-btn>
      <q-btn flat label="關閉" color="primary" v-close-popup />
    </q-card-actions>
  </q-card>
</template>

<script>
  import { mapActions, mapGetters } from "vuex"
  export default {
    name: "PurchaseCheckDetail",
    props: {
      handleClickReturnEvent: {
        type: Function
      }
    },
    data() {
      return {
        filter: '',
        columns: [
          { name: 'status', label: '狀態'},
          { name: 'title', align: 'center', label: '名稱', field: 'title'},
          { name: 'safeStock', label: '安全庫存', field: 'safeStock'},
          { name: 'totalStock', label: '現有庫存', field: 'totalStock'},
          { name: 'quantity', label: '採購數量', field: 'quantity'},
          { name: 'price', label: '採購金額', field: 'price'},
          // { name: 'date', label: '建立日期'},
          { name: 'action', label: '操作', align: 'center', field: 'id' }
        ],
        tableSet: {
            sortBy: 'desc',
            descending: false,
            page: 1,
            rowsPerPage: 10
        },
      }
    },
    computed: {
      ...mapGetters(['purchaseCheckDetail', 'purchaseCheckStatus'])
    },
    created() {
    },
    methods: {
      handlePurchaseCheckStatus() {
        return this.purchaseCheckDetail.status === 0 
      },
      handlePurchasePassClick() {
        this.$q.dialog({
          dark: true,
          title: '確認！',
          message: '是否確定要通過此張審核單？',
          cancel: true,
          persistent: true
        }).onOk(() => {
          this.$store.dispatch("purchaseCheckUpdatePass", this.purchaseCheckDetail.id).then(res => {
            if (res.Answer) { 
              this.purchaseCheckDetail.purchase_id = res.PurchaseID
              this.purchaseCheckDetail.status = 1
            }
           
          })
        })
      },
      ...mapActions(["purchaseCheckUpdate"])
    }
  }
</script>

<style>

</style>